<template>
  <div class="group-detail">
    <div class="content-wrapper">
      <div class="main-content">
        <div class="main-content__csv-box">
          <p>Academic Calendar csv</p>
          <FileInput v-model="selectedCsv" @changedFile="errors = null"/>
        </div>
        <div class="main-content__msg-box">
          <ErrorCsv :errorMessages="errors" />
        </div>
      </div>
      <div class="button-container">
        <b-button pill variant="primary"
          :disabled="isImporting"
          @click="confirmUploadCsv">Import</b-button>
      </div>
    </div>
    <Loading :isLoading="isImporting" />
  </div>
</template>

<script lang="ts">
import _ from 'lodash';
import FileInput from '@/components/parts/inputItem/FileInput.vue';
import ErrorCsv from '@/components/parts/ErrorCsv.vue';
import { readCsv, countRecords } from '@/utils/csv'
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator'
import { AssignmentStatus } from '@/store/groups/formation/types';
import Loading from '@/components/parts/modal/Loading.vue'

@Component({
  components: {
    FileInput,
    ErrorCsv,
    Loading,
  },
})
export default class AcademicCalendar extends Vue {
  @Prop({ required: true }) selectedAssignment!: AssignmentStatus

  selectedCsv: File|null = null

  errors: string[]|string|Object|null = null

  isImporting: boolean = false

  /**
   * インポートするCSVのチェック
   */
  async confirmUploadCsv() {
    if (this.isImporting) return
    if (!this.selectedCsv) {
      this.errors = 'required csv file.'
      return
    }

    this.errors = null
    try {
      const reader = await readCsv(this.selectedCsv)
      const recordsCount = countRecords(reader);
      const isOk = await this.$bvModal.msgBoxConfirm(`Import ${recordsCount} academic calendars. Is it OK?`)

      if (isOk) {
        this.importAcademicCalendar()
      }
    } catch (error) {
      this.errors = 'selected file has error. please select file again.'
      this.selectedCsv = null
    }
  }

  /**
   * CSVインポート
   */
  importAcademicCalendar() {
    if (_.isNull(this.selectedAssignment)) {
      throw Error('アカデミックカレンダーインポートの年度学期が選択されていません')
    }

    this.isImporting = true
    this.$store.dispatch('importAcademicCalendarByCsv', {
      assignment: this.selectedAssignment,
      csv: this.selectedCsv,
    })
      .then(() => {
        this.$bvModal.msgBoxOk('Success !')
          .then(() => this.$emit('complete'))
      })
      .catch((error) => {
        this.errors = error
      })
      .finally(() => {
        this.isImporting = false
      })
  }

  checkError(error: string) {
    this.errors = error
  }
}

</script>

<style scoped>
h1 {
  text-align: center;
  margin-bottom:20px;
}

.sub-title {
  padding:10px;
  margin-bottom: 20px;
  background: #DDEAF6;
  display: flex;
  align-items: center;
}

.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
  min-height: 500px;
}

.content-wrapper {
  background: #D8D8D8;
  padding: 20px 20px;
}

.button-container {
  display: flex;
  justify-content: center;
}

.import-button {
  margin-left:10px;
  display: block;
  text-decoration: none;
  color: #ffffff;
  min-width: 120px;
  font-size:15px;
  line-height: 15px;
  text-align: center;
  padding: 10px;
  border: 3px solid #2E75B5;
  border-radius: 20px;
  cursor: pointer;
  transition: .2s;
  user-select:none;
  background: #2E75B5;
}

.import-button:hover {
  background: #fff;
  color: #2E75B5;
}

.main-content p {
  display: block;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
}

.main-content__csv-box {
  margin-bottom:70px;
  padding-right: 30px;
  padding-left: 30px;
}
</style>
